import { useState, type FormEvent } from 'react';
import { useClarifyTask } from '../hooks/useTaskMutations';

interface ClarificationFormProps {
  taskId: string;
  questions: string[];
}

export function ClarificationForm({ taskId, questions }: ClarificationFormProps) {
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const clarify = useClarifyTask(taskId);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    clarify.mutate(answers);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <p className="text-sm text-gray-600">
        The AI needs more information to proceed. Please answer:
      </p>

      {questions.map((question) => (
        <div key={question}>
          <label className="block text-sm font-medium text-gray-700 mb-1">{question}</label>
          <input
            type="text"
            value={answers[question] ?? ''}
            onChange={(e) => setAnswers((prev) => ({ ...prev, [question]: e.target.value }))}
            required
            className="input"
          />
        </div>
      ))}

      <button type="submit" disabled={clarify.isPending} className="btn btn-primary">
        {clarify.isPending ? 'Submitting...' : 'Submit Answers'}
      </button>
    </form>
  );
}
